import Api from '@/common/fetch.js'
import { discountApiRoute } from '@/common/config'

export default {
    login (request) {
        return Api.post(discountApiRoute, request)
    },
    getInvoice (request) {
        return Api.post(discountApiRoute + '/getInvoice', request)
    },
    getDiscounts (request) {
        return Api.post(discountApiRoute + '/getDiscounts', request)
    },
    setDiscount (request) {
        return Api.post(discountApiRoute + '/setDiscount', request)
    },
}
